import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const Danger = (param)=>{
    let { size = 24, testId, style, className } = param;
    const strokeWidth = 1.5 * (24 / size);
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 14.04V8.13",
                stroke: "currentColor",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 18.29C12.5743 18.29 13.04 17.8244 13.04 17.25C13.04 16.6756 12.5743 16.21 12 16.21C11.4256 16.21 10.96 16.6756 10.96 17.25C10.96 17.8244 11.4256 18.29 12 18.29Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.40002 3.79001L1.83002 16.92C0.680018 18.92 2.12002 21.42 4.43002 21.42H19.58C21.89 21.42 23.33 18.92 22.18 16.92L14.6 3.79001C13.45 1.79001 10.56 1.79001 9.40002 3.79001Z",
                stroke: "currentColor",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
